module.exports = __webpack_public_path__ + "img/509.operating_instructions.d0e6ffad.svg";